import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

export const ModalUpdateBatch = ({
  show,
  toggle,
  handleResumeMandate,
  isResuming,
  openDropdownId
}) => {
  const [target, setTarget] = useState("");

  const handleSend = async() => {
    const payload = {
      status: target,
      batchId: openDropdownId
    };

    await handleResumeMandate(payload); // pass data up
  };

  return (
    <Modal show={show} onHide={toggle} backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>Update Batch</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p>Are you sure you want to update the batch?</p>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Status</Form.Label>
            <Form.Select
              value={target}
              onChange={(e) => setTarget(e.target.value)}
            >
              <option value="">-- Select a Target --</option>
              <option value="pending">Pending</option>
              <option value="processing">Processing</option>
              <option value="completed">Completed</option>
              {/* Add more options as needed */}
            </Form.Select>
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button
          style={{
            fontSize: "0.8rem",
            fontWeight: 500,
            border: 0,
          }}
          onClick={handleSend}
          disabled={isResuming || !target}
        >
          {isResuming ? "Submitting, please wait.." : "Submit"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
